import { render } from "./IFrame.vue?vue&type=template&id=4307fbe4&scoped=true"
import script from "./IFrame.vue?vue&type=script&lang=js"
export * from "./IFrame.vue?vue&type=script&lang=js"

import "./IFrame.vue?vue&type=style&index=0&id=4307fbe4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4307fbe4"]])

export default __exports__